import { render, staticRenderFns } from "./TablePriorityHandler.vue?vue&type=template&id=0df65308&scoped=true"
import script from "./TablePriorityHandler.vue?vue&type=script&lang=js"
export * from "./TablePriorityHandler.vue?vue&type=script&lang=js"
import style0 from "./TablePriorityHandler.vue?vue&type=style&index=0&id=0df65308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df65308",
  null
  
)

export default component.exports